<script setup lang="ts">
import { type Contract, Form } from '~/layers/forms/models'

type Props = { modelValue: Contract; coverageTypeCode?: string | null }
const props = defineProps<Props>()

const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const { RemoteConfigurationStore } = stores()
</script>

<template>
  <FormsVehicleForm
    v-if="RemoteConfigurationStore?.ramoEnum === 'Auto'"
    v-model="model.vehicle"
    as-criteria
    show-asistance
    :validation-scope="Form.coverage"
    class="col-span-full"
    :coverage-type-code
  >
    <template #aditional-fields>
      <slot name="aditional-fields" />
    </template>
    <template #action>
      <slot name="action" />
    </template>
  </FormsVehicleForm>
  <FormsTravelForm
    v-if="RemoteConfigurationStore?.ramoEnum === 'Viajes'"
    v-model="model.travel"
    :validation-scope="Form.coverage"
    as-criteria
    class="col-span-full"
  >
    <template #aditional-fields>
      <slot name="aditional-fields" />
    </template>
    <template #action>
      <slot name="action" />
    </template>
  </FormsTravelForm>
</template>
